var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.56724C23.1174 2.94796 22.157 3.22197 21.1676 3.32869C22.1948 2.71848 22.9639 1.75445 23.3308 0.617474C22.367 1.19083 21.3111 1.59289 20.2101 1.80579C19.7499 1.31381 19.1933 0.921879 18.575 0.654414C17.9567 0.386949 17.2899 0.249684 16.6163 0.251172C13.8906 0.251172 11.6986 2.46052 11.6986 5.17173C11.6986 5.55246 11.7447 5.93318 11.8197 6.29948C7.73849 6.08605 4.09855 4.13628 1.67864 1.15106C1.23771 1.90419 1.00665 2.76171 1.00949 3.63442C1.00949 5.34191 1.87766 6.84749 3.20154 7.73296C2.42136 7.70224 1.65944 7.4878 0.977767 7.10708V7.16765C0.977767 9.55871 2.66795 11.5402 4.92056 11.9959C4.49761 12.1058 4.06251 12.162 3.62553 12.1632C3.30537 12.1632 3.00252 12.1315 2.69679 12.0882C3.31979 14.038 5.134 15.4542 7.29432 15.5003C5.60413 16.8242 3.48708 17.6029 1.18832 17.6029C0.775868 17.6029 0.395145 17.5885 0 17.5424C2.18051 18.9412 4.7677 19.7488 7.5539 19.7488C16.599 19.7488 21.5484 12.2555 21.5484 5.75147C21.5484 5.53804 21.5484 5.3246 21.534 5.11116C22.4915 4.41029 23.3308 3.54212 24 2.56724Z",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter_logo.aab4c8b35bec6e72b86226db19ff6020.svg";
export { ForwardRef as ReactComponent };